export enum AddressType {
  OriginalShipping,
  Shipping,
  SuggestedShipping,
  Return,
  Invoice,
}
